import React from 'react';
import { useFormik, useFormikContext } from 'formik';
import { useIntl } from 'react-intl';
import { images } from '../../../../app/pages/hotel-management/hotel-details/core/_models';
import ImageEditModal from '../../../../app/pages/hotel-management/hotel-details/image-edit-modal/ImageEditModal';
import { patchOne } from '../../../../app/services/common_requests';
import _ from 'lodash';
import { ID } from '../../../helpers';

interface SectionOneProps {
    image: string;
    isModalOpen: boolean;
    selectedImage: images | null;
    handleImageClick: (img: images) => void;
    handleCloseModal: () => void;
    handleUpdateImage: (updatedImage: { url: string; seoUrl?: string }) => void;
}

const SectionOne: React.FC<SectionOneProps> = ({
    image,
    isModalOpen,
    selectedImage,
    handleImageClick,
    handleCloseModal,
    handleUpdateImage,
  }) => {
    const initialValues ={
        id: '',
        image: '',
        seoUrl: '',
        Title: '',
        SubTitle: '',
        
        translations: [{ shortDescription: '', note: '', name: '' }],
    };
   const formik = useFormik({
    initialValues,
    onSubmit: async (values) => {
        const modifiedFields = Object.keys(values).reduce((acc, key) => {
            const typedKey = key as keyof typeof values;
            if (!_.isEqual(values[typedKey], initialValues[typedKey])) {
                acc[typedKey] = values[typedKey];
            }
            return acc;
        }, {} as Record<string, any>);
      
        try {
            await patchOne(modifiedFields, `/sectionone/${values.id}`)
        } catch (error) {
            console.error('Error:', error);
        }
    },
});
    const intl = useIntl();
  
    return (
      <form onSubmit={formik.handleSubmit}>
        <section className='d-flex align-items-center scroll-y py-4'>
          <div className='form-group mb-3 me-6'>
            <img
              src={image || formik.values.image}
              alt={formik.values.seoUrl}
              className='border-image h-175px'
              onClick={() => handleImageClick({ 
                _id: formik.values.id as unknown as ID,
                url: image || formik.values.image, 
                seoUrl: formik.values.seoUrl 
              })}
              style={{ cursor: 'pointer' }}
            />
          </div>
          <ImageEditModal
            isOpen={isModalOpen}
            onClose={handleCloseModal}
            selectedImage={selectedImage || { url: '', seoUrl: '' }}
            onSave={handleUpdateImage}
          />
          <div className='col-7 mb-3 me-4 justif-content-end'>
            <label className='me-3 mb-3'>
              <strong>Title :</strong>
            </label>
            <input
              type='text'
              className='form-control w-100'
              name='Title'
              value={formik.values.Title}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.Title && formik.errors.Title && (
              <div className='text-danger'>{formik.errors.Title as string}</div>
            )}
  
            <label className='mb-3 me-4'>
              <strong>Subtitle :</strong>
            </label>
            <input
              type='text'
              className='form-control w-100'
              name='SubTitle'
              value={formik.values.SubTitle}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.SubTitle && formik.errors.SubTitle && (
              <div className='text-danger'>{formik.errors.SubTitle as string}</div>
            )}
          </div>
         
        </section>
        <div className='modal-footer '>
            <button type='submit' className='btn btn-primary me-2'>
              {intl.formatMessage({ id: 'HEADER.SAVE' })}
            </button>
            <button type='button' className='btn btn-secondary'>
              {intl.formatMessage({ id: 'HEADER.RESET' })}
            </button>
          </div>
      </form>
    );
  };
  export default SectionOne;